import { tdsFetch, jsonToQuery } from '@/utils/fetch';

export const fetchCreate = (data) => {
  return tdsFetch('/disclosure-project', { method: 'POST', body: data })
}

export const fetchUpdate = (data) => {
  return tdsFetch('/disclosure-project', { method: 'PUT', body: data })
}

export const fetchInfo = (id) => {
  return tdsFetch(`/disclosure-project/${id}`, { method: 'GET' })
}

export const fetchList = (data) => {
  return tdsFetch(`/disclosure-project/page${jsonToQuery(data)}`, { method: 'GET' })
}

export const fetchTodoList = (data) => {
  return tdsFetch(`/disclosure-project/page/todo${jsonToQuery(data)}`, { method: 'GET' })
}

export const fetchDelete = (ids) => {
  return tdsFetch(`/disclosure-project/batch-delete`, { method: 'DELETE', body: ids })
}

export const fetchStatist = () => {
  return tdsFetch('/disclosure-project/statics', { method: 'GET' })
}